import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Header, Loader, Pagination, Select, Table, TableBody, TableFooter} from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { dropTitleCode } from '../../app/models/Restoration';


interface Props {
  title: string;
}

const ReelWiseSummary = ({ title }: Props) => {
  const { RestorationStore,userStore: { user },  } = useStore();
  const [selectedTitleCode, setSelectedTitleCode] = useState<string>('');
  const [activePage, setActivePage] = useState<number>(1);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [friendOptions,setFriendOptions]=useState<dropTitleCode[]>([]);
  const [loading,setLoading]=useState<boolean>(false);
  // const [friendOptions, setFriendOptions] = useState<
  //   { key: string; text: string; value: string }[]
  // >([]);
  const itemsperPage = 10;
  const  LoadData=async (titleCode:string) => {
    setSelectedTitleCode(titleCode);
    if(title === 'reel') {
      setLoading(true);
      setFilteredData([]);
      await RestorationStore.reelWiseReport(titleCode);
        const data=RestorationStore.reelWiseData;
        setFilteredData(data);
        setLoading(false);
    }
    else{
      setLoading(true);
      setFilteredData([]);
      await RestorationStore.plWiseReport(titleCode);
        const data=RestorationStore.plWiseData;
        setFilteredData(data);
        setLoading(false);
    }
  }
  const titleCodeData=async()=>{
  await RestorationStore.getLiveTitleCode();
  const projectCode = RestorationStore.dropTitleCode;
  setFriendOptions(projectCode);
  }
  const totalpage = Math.ceil(filteredData.length / itemsperPage);
  const startIndex = (activePage - 1) * itemsperPage;
  const endIndex = activePage * itemsperPage;
  const handlePageChange = (_e: any, { activePage }: any) => {
    setActivePage(activePage);
  };
  const getTotal = (property: keyof any): number => {
    return filteredData.reduce((total, item) => total + Number(item[property]), 0);
  };
useEffect(()=>{
  titleCodeData();
 // eslint-disable-next-line
},[]);
  return (
    <div className="reel-wise-table">
      {title === 'reel' ? (
        <Header>Reel Wise Status Report  - {user?.departmentName} </Header>
      ) : (
        <Header>Lead Status Summary by Title - {user?.departmentName}</Header>
      )}
      <div className="tr-dropdown">
        <label>Title Code:</label>
        <Select placeholder="Select Title code"
          search
          clearable
          options={friendOptions}
          value={selectedTitleCode}
          onChange={(e:any,data:any)=>{LoadData(data.value)}}
        />
      </div>
      {user?.departmentName==='Restoration' && (<div>
      <Table>
          <Table.Header>
            <Table.Row textAlign="center">
              <Table.HeaderCell colspan={4}>Title Information</Table.HeaderCell>
              <Table.HeaderCell colspan={2}>
                Pending With Operator
              </Table.HeaderCell>
              <Table.HeaderCell colspan={2}>Pending with QC</Table.HeaderCell>
              <Table.HeaderCell Colspan={2}>Pending with FQA</Table.HeaderCell>
              <Table.HeaderCell Colspan={2}>Pending with CQC</Table.HeaderCell>
              <Table.HeaderCell Colspan={2}>Pending with CC</Table.HeaderCell>
              <Table.HeaderCell Colspan={2}>Pending with WAVE</Table.HeaderCell>
              <Table.HeaderCell Colspan={2}>
                Total Approved Frame
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row textAlign="center">
              <Table.HeaderCell>Title Code</Table.HeaderCell>
              {title === 'reel' ? (
                <Table.HeaderCell>ReeL Name</Table.HeaderCell>
              ) : (
                <Table.HeaderCell>Cluster Name</Table.HeaderCell>
              )}
              <Table.HeaderCell>Total Frames</Table.HeaderCell>
              <Table.HeaderCell>Hours</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <TableBody>
          {loading && (
              <Table.Row>
                <Table.Cell colSpan={13} textAlign="center">
                <Loader size="massive" active inline="centered" />
                Please wait, this will take a few minutes...
                </Table.Cell>
              </Table.Row>
            )}
            {selectedTitleCode==='' && (
              <Table.Row>
              <Table.Cell colSpan={13} textAlign="center">
              Please select one title code from the Title Code List.
              </Table.Cell>
            </Table.Row>
            )}
            
            {filteredData.slice(startIndex, endIndex).map((items, index) => (
              <Table.Row key={index}>
                <Table.Cell>{items.title_Code}</Table.Cell>
                {title === 'reel' ? (
                  <Table.Cell>{items.reel_No}</Table.Cell>
                ) : (
                  <Table.Cell>{items.cluster_Name}</Table.Cell>
                )}

                <Table.Cell>{items.total_Frame}</Table.Cell>
                <Table.Cell>{items.hours}</Table.Cell>
                <Table.Cell>{items.pending_With_Operator}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_Operator / items.total_Frame) * 100,
                  )}
                  %
                </Table.Cell>
                <Table.Cell>{items.pending_With_QC}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_QC / items.total_Frame) * 100,
                  )}
                  %
                </Table.Cell>
                <Table.Cell>{items.pending_With_FQA}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_FQA / items.total_Frame) * 100,
                  )}
                  %
                   </Table.Cell>
                <Table.Cell>{items.pending_With_CQC}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_CQC / items.total_Frame) * 100,
                  )}
                  %
                </Table.Cell>
                <Table.Cell>{items.pending_With_CC}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_CC / items.total_Frame) * 100,
                  )}
                  %
                </Table.Cell>
                <Table.Cell>{items.pending_With_Wave}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_Wave / items.total_Frame) * 100,
                  )}
                  %
                </Table.Cell>
                <Table.Cell>
                  {items.total_Frame -
                    (items.pending_With_Operator +
                      items.pending_With_QC +
                      items.pending_With_FQA +
                      items.pending_With_CQC +
                      items.pending_With_CC +
                      items.pending_With_Wave)}
                </Table.Cell>
                <Table.Cell>
                  {Math.round(
                    ((items.total_Frame -
                      (items.pending_With_Operator +
                        items.pending_With_QC +
                        items.pending_With_FQA +
                        items.pending_With_CQC +
                        items.pending_With_CC +
                        items.pending_With_Wave)) /
                      items.total_Frame) *
                      100,
                  )}
                  %
                </Table.Cell>
              </Table.Row>
            ))}
          </TableBody>
          {filteredData.length !== 0 && <TableFooter>
          <Table.Row>
           <Table.HeaderCell style={{ fontWeight: 'bold' }} colSpan={2} >Grand Total</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('total_Frame')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('hours')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_Operator')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_Operator') > 0 ? Math.round((getTotal('pending_With_Operator')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_QC')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_QC') > 0 ? Math.round((getTotal('pending_With_QC')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_FQA')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_FQA') > 0 ? Math.round((getTotal('pending_With_FQA')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_CQC')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_CQC') > 0 ? Math.round((getTotal('pending_With_CQC')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_CC')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_CC') > 0 ? Math.round((getTotal('pending_With_CC')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_Wave')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_Wave') > 0 ? Math.round((getTotal('pending_With_Wave')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('total_Approval_frame')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('total_Approval_frame') > 0 ? Math.round((getTotal('total_Approval_frame')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
          </Table.Row>
          </TableFooter> }
        </Table>
        {totalpage === 1 ? (
          <></>
        ) : (
          <Pagination
            activePage={activePage}
            totalPages={totalpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>)}
      {user?.departmentName==='Colorization' && (
        <div>
          <Table>
          <Table.Header>
            <Table.Row textAlign="center">
              <Table.HeaderCell colspan={3}>Title Information</Table.HeaderCell>
              <Table.HeaderCell colspan={2}>
              Pending with Poly Creation 
              </Table.HeaderCell>
              <Table.HeaderCell colspan={2}>Pending with Colorization</Table.HeaderCell>
              <Table.HeaderCell Colspan={2}>Pending with QC</Table.HeaderCell>
              <Table.HeaderCell Colspan={2}>
                Total Approved Frame
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row textAlign="center">
              <Table.HeaderCell>Title Code</Table.HeaderCell>
              {title === 'reel' ? (
                <Table.HeaderCell>ReeL Name</Table.HeaderCell>
              ) : (
                <Table.HeaderCell>Cluster Name</Table.HeaderCell>
              )}
              <Table.HeaderCell>Total Frames</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
              <Table.HeaderCell>No of Frames</Table.HeaderCell>
              <Table.HeaderCell>%</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
    
          <Table.Body>
            {loading && (
              <Table.Row>
                <Table.Cell colSpan={13} textAlign="center">
                <Loader active inline='centered' size='massive' />
                Please wait, this will take a few minutes...
                </Table.Cell>
              </Table.Row>
            )}
            {selectedTitleCode==='' && (
              <Table.Row>
              <Table.Cell colSpan={13} textAlign="center">
              Please select one title code from the Title Code List.
              </Table.Cell>
            </Table.Row>
            )}
            
            {filteredData.slice(startIndex, endIndex).map((items, index) => (
              <Table.Row key={index}>
                <Table.Cell>{items.title_Code}</Table.Cell>
                {title === 'reel' ? (
                  <Table.Cell>{items.reel_No}</Table.Cell>
                ) : (
                  <Table.Cell>{items.cluster_Name}</Table.Cell>
                )}

                <Table.Cell>{items.total_Frame}</Table.Cell>
                <Table.Cell>{items.pending_With_Operator}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_Operator / items.total_Frame) * 100,
                  )}
                  %
                </Table.Cell>
                <Table.Cell>{items.pending_With_QC}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_QC / items.total_Frame) * 100,
                  )}
                  %
                </Table.Cell>
                <Table.Cell>{items.pending_With_FQA}</Table.Cell>
                <Table.Cell>
                  {Math.round(
                    (items.pending_With_FQA / items.total_Frame) * 100,
                  )}
                  %
                </Table.Cell>
                <Table.Cell>
                  {items.total_Frame -
                    (items.pending_With_Operator +
                      items.pending_With_QC +
                      items.pending_With_FQA +
                      items.pending_With_CC +
                      items.pending_With_Wave)}
                </Table.Cell>
                <Table.Cell>
                  {Math.round(
                    ((items.total_Frame -
                      (items.pending_With_Operator +
                        items.pending_With_QC +
                        items.pending_With_FQA +
                        items.pending_With_CC +
                        items.pending_With_Wave)) /
                      items.total_Frame) *
                      100,
                  )}
                  %
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
          {filteredData.length !== 0 && <TableFooter>
          <Table.Row>
           <Table.HeaderCell style={{ fontWeight: 'bold' }} colSpan={2} >Grand Total</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('total_Frame')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_Operator')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_Operator') > 0 ? Math.round((getTotal('pending_With_Operator')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_QC')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_QC') > 0 ? Math.round((getTotal('pending_With_QC')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_FQA')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('pending_With_FQA') > 0 ? Math.round((getTotal('pending_With_FQA')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('total_Approval_frame')}</Table.HeaderCell>
           <Table.HeaderCell style={{ fontWeight: 'bold' }}>{getTotal('total_Approval_frame') > 0 ? Math.round((getTotal('total_Approval_frame')/getTotal('total_Frame'))*100).toString()+'%':'0%'}</Table.HeaderCell>
          </Table.Row>
          </TableFooter> }
       
          </Table>
        </div>
      )}
    </div> 
  );
};

export default observer(ReelWiseSummary);
